<template>
    <div class="header-bar header-fixed header-app header-bar-detached">
        <a data-bs-toggle="offcanvas" data-bs-target="#menu-main" href="#" v-if="!$route.meta.isBack"><i class="bi bi-list color-theme"></i></a>
        <a href="javascript:void(0)" v-if="$route.meta.isBack"><i class="bi bi-arrow-left-circle-fill" @click="back()"></i></a>
        <a href="#" class="header-title color-theme">{{ $route.meta.title }}</a>
        <a href="#" data-bs-toggle="offcanvas" data-bs-target="#menu-color"><i class="bi bi-palette-fill font-13 color-highlight"></i></a>
        <a href="#" data-bs-toggle="offcanvas" data-bs-target="#menu-setting"><i class="font-14 bi bi-gear-fill"></i></a>
        <a href="#" class="show-on-theme-light" data-toggle-theme><i class="bi bi-moon-fill font-13"></i></a>
        <a href="#" class="show-on-theme-dark" data-toggle-theme><i class="bi bi-lightbulb-fill color-yellow-dark font-13"></i></a>
    </div>
</template>

<script>
export default {
    name: 'Header',
    methods: {
        back() {
            this.$router.back()
        }
    }
}
</script>